"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Box, useMultiStyleConfig, forwardRef, Button, Text, } from "@chakra-ui/react";
import { SvgSpriteConsumer } from "../../atoms";
const ButtonToggle = forwardRef(({ selected: userSelected, onChange, buttons }, ref) => {
    const styles = useMultiStyleConfig("ButtonToggle");
    const [selected, setSelected] = useState(userSelected !== null && userSelected !== void 0 ? userSelected : 0);
    useEffect(() => {
        setSelected(userSelected !== null && userSelected !== void 0 ? userSelected : 0);
    }, [userSelected]);
    useEffect(() => {
        if (userSelected !== undefined && onChange === undefined) {
            // eslint-disable-next-line no-console
            console.warn("Warning: You provided a `selected` prop to a ButtonToggle component without an `onChange` handler. This will render a read-only component.");
        }
    }, [userSelected, onChange]);
    return (_jsx(Box, Object.assign({ ref: ref, sx: styles.container }, { children: buttons.map((_a, buttonIndex) => {
            var { svgId, onClick, label } = _a, otherButtonProps = __rest(_a, ["svgId", "onClick", "label"]);
            return (_jsx(Button, Object.assign({ variant: "icon", sx: styles.button }, (buttonIndex === selected
                ? { className: "_sdxIsSelected" }
                : {}), Object.assign(Object.assign({}, (buttonIndex === 0
                ? {
                    borderTopLeftRadius: 50,
                    borderBottomLeftRadius: 50,
                    borderLeft: "1px solid",
                }
                : {})), (buttonIndex === buttons.length - 1
                ? {
                    borderTopRightRadius: 50,
                    borderBottomRightRadius: 50,
                    borderRight: "1px solid",
                }
                : {})), { onClick: (e) => {
                    if (userSelected === undefined) {
                        setSelected(buttonIndex);
                    }
                    onChange === null || onChange === void 0 ? void 0 : onChange(buttonIndex);
                    onClick === null || onClick === void 0 ? void 0 : onClick(e);
                }, leftIcon: _jsx(SvgSpriteConsumer, { svgId: svgId, size: 16 }) }, otherButtonProps, { children: label && _jsx(Text, Object.assign({ variant: "body.smallDemibold" }, { children: label })) }), `button-toggle-${buttonIndex}`));
        }) })));
});
ButtonToggle.displayName = "ButtonToggle";
export default ButtonToggle;
//# sourceMappingURL=ButtonToggle.js.map